import { between, boolean, entity, equals, isNull, notNull, number, query, string, truthy } from '~/prix'
import asGeoJson from '~/prix/functions/asGeoJson'

interface AgentReportVisitLocationsValues {
  attendant: {
    id: string
    name?: string
  }
  startDate?: string
  endDate?: string
}

export default function agentReportVisitLocationsListQuery(values: AgentReportVisitLocationsValues) {
  const attendantCpf = values?.attendant?.id ?? undefined
  const startDate = values?.startDate ?? undefined
  const endDate = values?.endDate ?? undefined

  return query('legalEntityAttendance')
    .select({
      attendanceId: entity('legalEntityAttendance').property('id'),
      legalEntityId: entity('legalEntityAttendance').property('legalEntityId'),
      legalEntityName: entity('legalEntity').property('tradeName'),
      legalEntityState: entity('legalEntity').property('state'),
      legalEntityCoordinates: asGeoJson(entity('legalEntityGeoprocessing').property('pointOnStreet')),
      legalEntityDataSource: entity('legalEntityAttendanceDataSource').property('dataSourceId'),
      attendanceStartDate: entity('legalEntityAttendance').property('startDate'),
      cityId: entity('legalEntityGeoprocessing').property('cityId'),
      legalEntitySize: entity('legalEntity').property('sizeAbbreviation'),
      isBranch: entity('legalEntity').property('isBranch'),
    })
    .join({
      current: entity('legalEntityAttendance').property('id'),
      target: entity('legalEntityAttendanceDataSource').property('legalEntityAttendanceId'),
      join: 'inner',
    })
    .join({
      current: entity('legalEntityAttendance').property('legalEntityId'),
      target: entity('legalEntity').property('id'),
      join: 'inner',
    })
    .join({
      current: entity('legalEntity').property('id'),
      target: entity('legalEntityGeoprocessing').property('legalEntityId'),
      join: 'inner',
    })
    .join({
      current: entity('legalEntityAttendanceDataSource').property('dataSourceId'),
      target: entity('dataSource').property('id'),
      join: 'inner',
    })
    .where(
      ...[
        isNull(entity('legalEntity').property('deletedAt')),
        equals(entity('legalEntityAttendance').property('agentCpf'), string().value(attendantCpf)),
        equals(entity('dataSource').property('isActive'), boolean().value(true)),
        equals(entity('legalEntityAttendanceDataSource').property('dataSourceId'), number().value(8)),
        notNull(entity('legalEntityGeoprocessing').property('pointOnStreet')),
        startDate && endDate
          ? between(
              entity('legalEntityAttendance').property('startDate'),
              string().value(startDate),
              string().value(endDate),
            )
          : null,
      ].filter(truthy),
    )
}
